import styled from 'styled-components'
import { Card } from './styled'

export const SettingsCard = styled(Card)`
  background: #ffffff;
  border: 1px solid #e4ebf3;
  box-shadow: 0 12px 28px rgba(23, 55, 77, 0.08);
  border-radius: 18px;
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: auto;
  min-height: 210px;
  margin: 28px 0 0;
  padding: 24px 28px;
  cursor: default;

  &:hover {
    transform: none;
    border-color: #e4ebf3;
    box-shadow: 0 12px 28px rgba(23, 55, 77, 0.08);
  }
`

export const SettingsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;
`

export const SettingsTitle = styled.div`
  h3 {
    margin: 0 0 4px;
    font-size: 20px;
    color: #172b4d;
  }

  p {
    margin: 0;
    color: #718096;
    font-size: 14px;
  }
`

export const SettingsStatus = styled.span<{ tone: 'success' | 'warning' | 'neutral' }>`
  padding: 7px 12px;
  border-radius: 16px;
  background: ${(props) => (props.tone === 'success' ? '#e8f7ef' : props.tone === 'warning' ? '#fff4df' : '#eef2f6')};
  color: ${(props) => (props.tone === 'success' ? '#18794e' : props.tone === 'warning' ? '#9a6700' : '#526274')};
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`

export const SettingsFields = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const SettingsActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

export const SettingsFeedback = styled.p<{ error?: boolean }>`
  margin: 14px 0 0;
  color: ${(props) => (props.error ? '#b42318' : '#18794e')};
  font-size: 14px;
`
